import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ButtonSelectBanners from "./ButtonSelectBanners";
import ButtonSelectCities from "./ButtonSelectCities";
import ButtonSummary from "./ButtonSummary";
import ButtonSync from "./ButtonSync";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
  menuItem: {
    paddingLeft: 10,
    paddingRight: 10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  button: {
    marginRight: theme.spacing(1),
  },
}));

export default function ButtonConfig({ project }) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        color="primary"
        className={classes.button}
        onClick={handleOpenMenu}
        endIcon={<ExpandMoreIcon />}
      >
        Config
      </Button>
      <Menu
        id="config-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
      >
        <MenuItem className={classes.menuItem} onClick={handleCloseMenu}>
          {/* <Typography variant="body2" style={{ marginRight: '8px' }}>Banners:</Typography> */}
          <ButtonSelectBanners project={project} label ='Banners:' />
        </MenuItem>
        <MenuItem className={classes.menuItem} onClick={handleCloseMenu}>
          <ButtonSelectCities project={project} label ='Cities:' />
        </MenuItem>
        <MenuItem className={classes.menuItem} onClick={handleCloseMenu}>
          <ButtonSummary project={project} label ='Summary:' />
        </MenuItem>
        <MenuItem className={classes.menuItem} onClick={handleCloseMenu}>
          <ButtonSync project={project} label ='Sync:' />
        </MenuItem>
      </Menu>
    </>
  );
} 